import axios from "axios";
import Config from "../Config";

const base= Config.HTTP_BASE;

// Function to redirect to login with current path
const redirectToLogin = () => {
    const currentPath = window.location.href;
    const loginUrl = `${Config.HTTP_BASE}/login?redirect=${encodeURIComponent(currentPath)}`;
    window.location.href = loginUrl;
};

const rest = axios.create({
    baseURL: base,
    headers: {
        "Content-Type": "application/json",
        "redirectTo" : "zerodha_proxy",
    },
    withCredentials : true
});

// Add response interceptor to handle 401 errors
rest.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            redirectToLogin();
        }
        return Promise.reject(error);
    }
);

class RestUtil{
    get<T>(path:string) : Promise<T>{
        return rest.get<T>(path).then(resp => resp.data);
    }

    post<T>(path: string, data: any) :Promise<T> {
        return rest.post(path, data).then(resp => resp.data);
    }

    postForm<T>(path: string, data: FormData) : Promise<T> {
        return rest.post(path, data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then(resp => resp.data);
    }

    put<T>(path: string, data: any) :Promise<T> {
        return rest.put(path, data).then(resp => resp.data);
    }

    delete<T>(path: string, data?: any) :Promise<T> {
        return rest.delete(path, { data }).then(resp => resp.data);
    }
    constructor() {
        setInterval(()=>{
            // rest.get('/ping')
        }, 1000)
    }
}

let restUtil = new RestUtil();;
export default restUtil
